<template>
  <div>
    <v-dialog
      v-model="open"
      persistent
    >
      <v-card>
        <v-card-title>
          <div class="title text-xs-center">
            <i class="material-icons icon">contact_support</i>
          </div>

          <luci-btn-icon :config="exitBtnConfig" @callback="$emit('no-callback', item)" class="exit-btn"></luci-btn-icon>
        </v-card-title>

        <v-card-text class="text-xs-center">
          <h3 v-html="title" class="luci-subtitle"></h3>
          <p v-html="message" class="luci-text"></p>

          <v-img
            v-if="image"
            height="200px"
            contain
            :src="image"
          ></v-img>
        </v-card-text>

        <v-card-actions>
          <div class="actions text-xs-center">
            <div class="action-btn">
              <luci-btn-icon :config="yesBtnConfig" @callback="$emit('yes-callback', item)"></luci-btn-icon>
              <div class="yes-btn-text">{{ yesText }}</div>
            </div>

            <div class="action-btn">
              <luci-btn-icon :config="noBtnConfig" @callback="$emit('no-callback', item)"></luci-btn-icon>
              <div class="no-btn-text">{{ noText }}</div>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// TODO: move to Luci
import variables from '../../helpers/variables'

export default {
  name: 'ConfirmModal',
  props: {
    item: { type: Object, default: null },
    open: { type: Boolean },
    title: { type: String, default: 'Are you sure?' },
    message: { type: String },
    yesText: { type: String, default: 'Yes' },
    noText: { type: String, default: 'No' },
    image: { type: String, default: null }
  },
  computed: {
    yesBtnConfig () {
      return (
        {
          type: 'button',
          name: 'yes-btn',
          primary: true,
          icon: true,
          iconType: 'thumb_up',
          tooltip: this.yesText
        }
      )
    },
    noBtnConfig () {
      return (
        {
          type: 'button',
          name: 'no-btn',
          icon: true,
          iconType: 'thumb_down',
          tooltip: this.noText
        }
      )
    }
  },
  data () {
    return {
      exitBtnConfig: variables.exitBtnIconConfigOptions
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/modal';

  @include modal;

  .actions {
    max-width: 400px;
    margin: 0 auto;
    display: inline-flex;
  }
</style>
